export default {
	0: 'Sujeito disponibilidade',
	1: 'Disponível',
	2: 'Indisponível',
	AVAILABLE: 'Disponível',
	UNAVAILABLE: 'Indisponível',
	DISCONTINUED: 'Descontinuado'
};
